
import { mapMutations } from 'vuex'

export default {
  name: 'HeaderBar',
  props: {
    isOpened: {
      type: Boolean,
      default: true,
    },
    user: {
      type: Object,
      default() {},
    },
    img: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isDropdownOpen: false,
    }
  },
  computed: {
    requiredDocuments() {
      return localStorage.required_documents
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('credential/clearToken')
      location.reload()
    },
    ...mapMutations({ toggleClassModal: 'modal/toggleClassModal' }),
    perfilToPtBr(perfil) {
      const perfils = new Map([
        ['student', ''],
        ['professor', 'Professor'],
        ['coordinator', 'Coordenador'],
      ])
      return perfils.get(perfil)
    },
  },
}
